// import { useContext } from "react";
// import styles from "./MaflamCard.module.css";
// import { AboutusPageContext } from "../../store/AboutUsPageContext";

// const MaflamCard = () => {
//   const { aboutusScreenDetails, loading, error } =
//     useContext(AboutusPageContext);

//   if (loading) return <p>Loading...</p>; // Handle loading state
//   if (error) return <p>Error loading data</p>; // Handle error state

//   // Extract the title and mentors array from the context
//   const mentorsTitle =
//     aboutusScreenDetails?.aboutUsDetailsSec70?.mentorTitle || "Maflam Mentors";
//   const mentors = aboutusScreenDetails?.aboutUsDetailsSec7 || [];
//   console.log(mentors);

//   return (
//     <div className={styles.container}>
//       <h2 className={styles.title}>{mentorsTitle}</h2>
//       <div className={styles.grid}>
//         {mentors.map((mentor, index) => (
//           <div className={styles.card} key={index}>
//             <img
//               src={mentor.imageUrl}
//               alt={mentor.title}
//               className={styles.image}
//             />
//             <div className={styles.overlay}>
//               <p className={styles.name}>{mentor.title}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MaflamCard;

// import { useContext, useState } from "react";
// import styles from "./MaflamCard.module.css";
// import { AboutusPageContext } from "../../store/AboutUsPageContext";
// import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";

// const MaflamCard = () => {
//   const { aboutusScreenDetails, loading, error } =
//     useContext(AboutusPageContext);
//   const { direction } = useContext(LanguageContext);
//   const [selectedMentor, setSelectedMentor] = useState(null);

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error loading data</p>;

//   const mentorsTitle =
//     aboutusScreenDetails?.aboutUsDetailsSec70?.mentorTitle || "Maflam Mentors";
//   const backendMentors = aboutusScreenDetails?.aboutUsDetailsSec7 || [];

//   // Frontend-only metadata mapped by title (fallback key)
//   const mentorDetails = {
//     "Osama Rubihan": {
//       nameEn: "Osama Rubihan",
//       nameAr: "أسامة ربيحان",
//       descriptionEn:
//         "Osama Rubihan, a Saudi Director of Photography who has dedicated over five years to mastering the art of visual storytelling in film. His work spans both documentary and narrative films, including the acclaimed feature documentary My Dad (Shahid Original), The Story of My Life (in post-production), and the narrative feature Honor of Thieves. His portfolio includes standout shorts like the documentary Al-Jakar on Netflix, and the narrative films Laila and The Post, reflecting his commitment to the craft and growth as a visual filmmaker. Osama has also mentored emerging talents through training programs at Maflam and Jeddah Dox, supporting the next generation of storytellers.",
//       descriptionAr:
//         "مدير تصوير سعودي، كرس أكثر من خمس سنوات لإتقان فن السرد البصري في صناعة الأفلام. شارك في أعمال وثائقية وروائية، من أبرزها الفيلم الوثائقي الطويل أبوي من إنتاج شاهد الأصلي، وفيلم قصة حياتي الذي يُعد حالياً في مرحلة ما بعد الإنتاج، إلى جانب الفيلم الروائي شرف اللصوص. تشمل أعماله أيضًا أفلامًا قصيرة بارزة مثل الوثائقي الجكر المتاح على نتفلكس، والروائيين ليلى والبريد، ما يعكس التزامه العميق بالحرفة وتطوره المستمر كصانع أفلام بصري. إلى جانب عمله الإبداعي، أسهم أسامة في تدريب عدد كبير من المتدربين والمهتمين بصناعة الأفلام من خلال برامجه التدريبية في مفلم وجدة دوكس، مؤكداً على دوره في دعم وتطوير الجيل القادم من صناع الأفلام.",
//       redirectLink: "#",
//     },
//     "Shahad  Almudawi": {
//       nameEn: "Shahad Almudawi",
//       nameAr: "شهد المدوي",
//       descriptionEn:
//         "Shahad AlMudawi is a Saudi documentary filmmaker and mentor with a solid background in directing and cinematography. She directed the short documentary Souq and was the cinematographer for the feature-length film The Story of Our Lives. Her work also includes innovative shows like Kursi Al-Muflemeen, Bikhtisar, and Maflam's Podcast, showcasing her creative range. She trained in directing on the MBC show The Million Land under the NEOM initiative and has contributed to filmmaker training programs with UNESCO and the Saudi Heritage Commission. Through Maflam’s internship program, she has mentored students from local and international universities. With a passion for storytelling and a drive to empower the next generation, Shahad continues to make a lasting impact in the film industry.",
//       descriptionAr:
//         "صانعة أفلام وثائقية سعودية ومرشدة في مجال صناعة الأفلام، تمتلك خبرة واسعة في الإخراج والتصوير السينمائي. أخرجت الفيلم الوثائقي القصير السوق وعملت كمصورة سينمائية للفيلم الوثائقي الطويل قصة حياتنا. كما أخرجت برامج متنوعة مثل كرسي المفلّمين وباختصار وبودكاست مَفلَم، مقدّمة محتوى مبتكر يلقى صدى لدى الجمهور. شاركت شهد في مشاريع بارزة، من بينها تدريبها في الإخراج في برنامج أرض المليون على قناة MBC ضمن مبادرة نيوم. كما أسهمت في تدريب صناع أفلام ناشئين من خلال برامج نظّمتها اليونسكو وهيئة التراث، بالإضافة إلى دورها كمرشدة في برنامج التدريب الداخلي بمفلم، حيث ساعدت طلاب جامعات محلية ودولية على تطوير مهاراتهم. تواصل شهد دعمها للجيل القادم من صناع الأفلام من خلال شغفها والتزامها العميق بالمجال.",
//       redirectLink: "#",
//     },
//     "Zakaria Bashir": {
//       nameEn: "Zakaria Bashir",
//       nameAr: "زكريا بشير",
//       descriptionEn:
//         "Zakaria Al-Bashir is a Somali filmmaker and theatre actor based in Jeddah, Saudi Arabia. He began his journey in the performing arts at a young age and later transitioned into filmmaking, directing short films that have been recognized at regional and international festivals. His debut film Laila received a Special Jury Award, and his follow-up The Post premiered at the 2024 Red Sea International Film Festival. A graduate of the Jeddah Dox program, Zakaria now mentors emerging filmmakers and contributes to training initiatives through Maflam. He also serves as a film advisor to the Ministry of Culture and Information and represents the National Theatre in Somalia, playing a key role in advancing the region’s cinematic and cultural development.",
//       descriptionAr:
//         "زكريا البشير مخرج أفلام وممثل مسرحي صومالي مقيم في جدة. بدأ شغفه بالفنون منذ الصغر من خلال المسرحيات الكلاسيكية والأفلام الهندية. انطلقت رحلته المسرحية من المدرسة، ثم الجمعية العربية للثقافة والفنون، حيث شارك في عروض مثل الصندوق المجنون، نريد أن نغني، وسوق العرب، ثم انتقل إلى مسرح جامعة الملك عبدالعزيز وشارك في مملوك جابر والتسوس. انتقل لاحقًا إلى الإخراج السينمائي، فقدم فيلمه القصير الأول ليلى الذي لاقى اهتمامًا واسعًا ونال جائزة لجنة التحكيم التقديرية، تبعه فيلمه البريد الذي عُرض في مهرجان البحر الأحمر السينمائي الدولي 2024. وهو أحد خريجي جدة دوكس، وأصبح لاحقًا مدربًا فيه، إلى جانب عمله ضمن فريق مَفلَم في تدريب صناع الأفلام من خلال ورش احترافية على مدار العام. يعمل زكريا اليوم كمخرج مستقل ومستشار سينمائي لدى وزارة الإعلام والثقافة، ووكيلًا للمسرح الوطني في الصومال، حيث يساهم في تطوير البنية التحتية للسينما والمسرح إيمانًا منه بأن الفن أداة للتعبير والتغيير المجتمعي.",
//       redirectLink: "#",
//     },
//   };

//   // Merge backend + frontend info
//   const mentors = backendMentors.map((mentor) => ({
//     ...mentor,
//     ...(mentorDetails[mentor.title] || {}),
//   }));

//   console.log(mentors);

//   return (
//     <>
//       <div className={styles.container}>
//         <h2 className={styles.title}>{mentorsTitle}</h2>
//         <div className={styles.grid}>
//           {mentors.map((mentor, index) => (
//             <div
//               className={styles.card}
//               key={index}
//               onClick={() => setSelectedMentor(mentor)}
//               style={{ cursor: "pointer" }}
//             >
//               <img
//                 src={mentor.imageUrl}
//                 alt={mentor.title}
//                 className={styles.image}
//               />
//               <div className={styles.overlay}>
//                 <p className={styles.name}>{mentor.title}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       {/* Mentor Modal */}
//       {selectedMentor && (
//         <div className={styles.modalOverlay}>
//           <div
//             className={styles.modalContent}
//             dir={direction}
//             style={{
//               background: `linear-gradient(0deg, rgba(10, 23, 31, 0.70) 0%, rgba(10, 23, 31, 0.70) 100%), url(${selectedMentor.imageUrl}) lightgray 50% / cover no-repeat`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//             }}
//           >
//             <div className={styles.modalGrid}>
//               <div className={styles.modalText}>
//                 <button
//                   className={`${styles.closeButton} ${
//                     direction === "rtl" ? styles.rtl : styles.ltr
//                   }`}
//                   onClick={() => setSelectedMentor(null)}
//                 >
//                   &times;
//                 </button>

//                 <div className={styles.header}>
//                   <h5 className={styles.toggle}>
//                     {direction === "rtl" ? "عن المدرب" : "About the Mentor"}
//                   </h5>
//                   <hr className={styles.line} />
//                 </div>
//                 <h2 className={styles.mentorName}>
//                   {direction === "rtl"
//                     ? selectedMentor.title
//                     : selectedMentor.nameEn || selectedMentor.title}
//                 </h2>

//                 <div className={styles.paragraph}>
//                   {direction === "rtl"
//                     ? selectedMentor.descriptionAr
//                     : selectedMentor.descriptionEn}
//                 </div>

//                 {/* {selectedMentor.redirectLink && ( */}
//                 <a
//                   href={selectedMentor.redirectLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <button className={styles.modalButton}>
//                     {direction === "rtl" ? "عرض الدورات" : "View Courses"}
//                   </button>
//                 </a>
//                 {/* )} */}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default MaflamCard;

import { useContext, useState } from "react";
import styles from "./MaflamCard.module.css";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";

const mentorDetails = {
  "Osama Rubihan": {
    nameEn: "Osama Rubihan",
    nameAr: "أسامة ربيحان",
    imageUrl:
      "https://maflamlmsnew.s3.me-central-1.amazonaws.com/marketingphotos/mentor2.png",
    descriptionEn:
      "Osama Rubihan, a Saudi Director of Photography who has dedicated over five years to mastering the art of visual storytelling in film. His work spans both documentary and narrative films, including the acclaimed feature documentary My Dad (Shahid Original), The Story of My Life (in post-production), and the narrative feature Honor of Thieves. His portfolio includes standout shorts like the documentary Al-Jakar on Netflix, and the narrative films Laila and The Post, reflecting his commitment to the craft and growth as a visual filmmaker. Osama has also mentored emerging talents through training programs at Maflam and Jeddah Dox, supporting the next generation of storytellers.",
    descriptionAr:
      "مدير تصوير سعودي، كرس أكثر من خمس سنوات لإتقان فن السرد البصري في صناعة الأفلام. شارك في أعمال وثائقية وروائية، من أبرزها الفيلم الوثائقي الطويل أبوي من إنتاج شاهد الأصلي، وفيلم قصة حياتي الذي يُعد حالياً في مرحلة ما بعد الإنتاج، إلى جانب الفيلم الروائي شرف اللصوص. تشمل أعماله أيضًا أفلامًا قصيرة بارزة مثل الوثائقي الجكر المتاح على نتفلكس، والروائيين ليلى والبريد، ما يعكس التزامه العميق بالحرفة وتطوره المستمر كصانع أفلام بصري. إلى جانب عمله الإبداعي، أسهم أسامة في تدريب عدد كبير من المتدربين والمهتمين بصناعة الأفلام من خلال برامجه التدريبية في مفلم وجدة دوكس، مؤكداً على دوره في دعم وتطوير الجيل القادم من صناع الأفلام.",
    redirectLink: "#",
  },
  "Shahad  Almudawi": {
    nameEn: "Shahad Almudawi",
    nameAr: "شهد المدوي",
    imageUrl:
      "https://maflamlmsnew.s3.me-central-1.amazonaws.com/marketingphotos/mentor3.png",
    descriptionEn:
      "Shahad AlMudawi is a Saudi documentary filmmaker and mentor with a solid background in directing and cinematography. She directed the short documentary Souq and was the cinematographer for the feature-length film The Story of Our Lives. Her work also includes innovative shows like Kursi Al-Muflemeen, Bikhtisar, and Maflam's Podcast, showcasing her creative range. She trained in directing on the MBC show The Million Land under the NEOM initiative and has contributed to filmmaker training programs with UNESCO and the Saudi Heritage Commission. Through Maflam’s internship program, she has mentored students from local and international universities. With a passion for storytelling and a drive to empower the next generation, Shahad continues to make a lasting impact in the film industry.",
    descriptionAr:
      "صانعة أفلام وثائقية سعودية ومرشدة في مجال صناعة الأفلام، تمتلك خبرة واسعة في الإخراج والتصوير السينمائي. أخرجت الفيلم الوثائقي القصير السوق وعملت كمصورة سينمائية للفيلم الوثائقي الطويل قصة حياتنا. كما أخرجت برامج متنوعة مثل كرسي المفلّمين وباختصار وبودكاست مَفلَم، مقدّمة محتوى مبتكر يلقى صدى لدى الجمهور. شاركت شهد في مشاريع بارزة، من بينها تدريبها في الإخراج في برنامج أرض المليون على قناة MBC ضمن مبادرة نيوم. كما أسهمت في تدريب صناع أفلام ناشئين من خلال برامج نظّمتها اليونسكو وهيئة التراث، بالإضافة إلى دورها كمرشدة في برنامج التدريب الداخلي بمفلم، حيث ساعدت طلاب جامعات محلية ودولية على تطوير مهاراتهم. تواصل شهد دعمها للجيل القادم من صناع الأفلام من خلال شغفها والتزامها العميق بالمجال.",
    redirectLink: "#",
  },
  "Zakaria Bashir": {
    nameEn: "Zakaria Bashir",
    nameAr: "زكريا بشير",
    imageUrl:
      "https://maflamlmsnew.s3.me-central-1.amazonaws.com/marketingphotos/mentor1.png",
    descriptionEn:
      "Zakaria Al-Bashir is a Somali filmmaker and theatre actor based in Jeddah, Saudi Arabia. He began his journey in the performing arts at a young age and later transitioned into filmmaking, directing short films that have been recognized at regional and international festivals. His debut film Laila received a Special Jury Award, and his follow-up The Post premiered at the 2024 Red Sea International Film Festival. A graduate of the Jeddah Dox program, Zakaria now mentors emerging filmmakers and contributes to training initiatives through Maflam. He also serves as a film advisor to the Ministry of Culture and Information and represents the National Theatre in Somalia, playing a key role in advancing the region’s cinematic and cultural development.",
    descriptionAr:
      "زكريا البشير مخرج أفلام وممثل مسرحي صومالي مقيم في جدة. بدأ شغفه بالفنون منذ الصغر من خلال المسرحيات الكلاسيكية والأفلام الهندية. انطلقت رحلته المسرحية من المدرسة، ثم الجمعية العربية للثقافة والفنون، حيث شارك في عروض مثل الصندوق المجنون، نريد أن نغني، وسوق العرب، ثم انتقل إلى مسرح جامعة الملك عبدالعزيز وشارك في مملوك جابر والتسوس. انتقل لاحقًا إلى الإخراج السينمائي، فقدم فيلمه القصير الأول ليلى الذي لاقى اهتمامًا واسعًا ونال جائزة لجنة التحكيم التقديرية، تبعه فيلمه البريد الذي عُرض في مهرجان البحر الأحمر السينمائي الدولي 2024. وهو أحد خريجي جدة دوكس، وأصبح لاحقًا مدربًا فيه، إلى جانب عمله ضمن فريق مَفلَم في تدريب صناع الأفلام من خلال ورش احترافية على مدار العام. يعمل زكريا اليوم كمخرج مستقل ومستشار سينمائي لدى وزارة الإعلام والثقافة، ووكيلًا للمسرح الوطني في الصومال، حيث يساهم في تطوير البنية التحتية للسينما والمسرح إيمانًا منه بأن الفن أداة للتعبير والتغيير المجتمعي.",
    redirectLink: "#",
  },
};

const MaflamCard = () => {
  const [selectedMentor, setSelectedMentor] = useState(null);
  const { direction } = useContext(LanguageContext);

  const mentors = Object.values(mentorDetails);

  return (
    <>
      <div className={styles.container}>
        <h2 className={styles.title}>Maflam Mentors</h2>
        <div className={styles.grid}>
          {mentors.map((mentor, index) => (
            <div
              className={styles.card}
              key={index}
              onClick={() => setSelectedMentor(mentor)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={mentor.imageUrl}
                alt={mentor.nameEn}
                className={styles.image}
              />
              <div className={styles.overlay}>
                <p className={styles.name}>
                  {direction === "rtl" ? mentor.nameAr : mentor.nameEn}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedMentor && (
        <div className={styles.modalOverlay}>
          <div
            className={styles.modalContent}
            dir={direction}
            style={{
              background: `linear-gradient(0deg, rgba(10, 23, 31, 0.70) 0%, rgba(10, 23, 31, 0.70) 100%), url(${selectedMentor.imageUrl}) lightgray 50% / cover no-repeat`,
              backgroundSize: "cover",
              // backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className={styles.modalGrid}>
              <div className={styles.modalText}>
                <button
                  className={`${styles.closeButton} ${
                    direction === "rtl" ? styles.rtl : styles.ltr
                  }`}
                  onClick={() => setSelectedMentor(null)}
                >
                  &times;
                </button>

                <div className={styles.header}>
                  <h5 className={styles.toggle}>
                    {direction === "rtl" ? "عن المدرب" : "About the Mentor"}
                  </h5>
                  <hr className={styles.line} />
                </div>

                <h2 className={styles.mentorName}>
                  {direction === "rtl"
                    ? selectedMentor.nameAr
                    : selectedMentor.nameEn}
                </h2>

                <div className={styles.paragraph}>
                  {direction === "rtl"
                    ? selectedMentor.descriptionAr
                    : selectedMentor.descriptionEn}
                </div>

                <a
                  href={selectedMentor.redirectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className={styles.modalButton}>
                    {direction === "rtl" ? "عرض الدورات" : "View Courses"}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MaflamCard;
